import { useRef, useCallback } from 'react';

/**
 * Make a debounced version of a function.
 *
 * @param {any} fn - The function to debounce
 * @param {number} delay - The delay in milliseconds
 * @returns {any} The debounced function
 */
export function useDebounce(fn, delay) {
    const timer = useRef(null);

    return useCallback(
        /**
         * Debounced function
         *
         * @param {...any} args - Arguments to pass to the function
         */
        (...args) => {
            // Clear the timeout if it exists
            if (timer.current) {
                clearTimeout(timer.current);
            }

            // Set a new timeout
            timer.current = setTimeout(() => {
                fn(...args);
            }, delay);
        },
        [fn, delay]
    );
}
